import DossierTechniqueWizardPage from "@features/creation/dossier-techniques/components/DossierTechniqueWizardPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/creation/dossier-techniques/create")({
  loader: requirePermission(PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.CREATE),
  staticData: {
    title: "Nouveau dossier technique",
    icon: null,
    permission: PERMISSIONS.CREATION.DOSSIER_TECHNIQUES.CREATE,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: CreateDossierTechniquePage,
});

function CreateDossierTechniquePage() {
  return <DossierTechniqueWizardPage />;
}
